import React  from 'react';

import { Container, Card, P, H1} from './DisclaimerElements';

const Disclaimer = () => {
  return (
    <>
    
      <Container>
      <Card>
              <H1> Disclaimer </H1>
                <P> Structural Connections is a recruitment company that strives to provide quality recruitment services to both employers and job seekers. While we make every effort to ensure the accuracy and reliability of the information provided, we cannot guarantee that all information on our website or provided by our recruiters is completely accurate, up-to-date, or applicable to your specific situation.  </P> 
                <P> We do not endorse or assume responsibility for the accuracy or reliability of any information, opinion, advice, or statement provided by third-party websites or services that may be linked to or from our website. We also do not guarantee that the candidates we provide will meet the specific requirements or expectations of any employer.</P>
                <P> The decision to hire a candidate or accept a job offer is solely the responsibility of the employer and the candidate. We strongly recommend that employers conduct their own due diligence and thorough screening process before hiring a candidate, and that job seekers carefully consider the job requirements and work environment before accepting a job offer.</P>
                <P> In no event shall Structural Connection be liable for any damages whatsoever, including but not limited to direct, indirect, special, or consequential damages, arising out of or in connection with the use or inability to use our services, our website, or the information provided by our recruiters. </P>
                <P> By using our services or accessing our website, you acknowledge and agree to the terms of this disclaimer. </P>
                </Card>
      
      </Container>
    </>
  )
}

export default Disclaimer;
